// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__5Co9I"};